import { Typography } from '@mui/material';
import React from 'react';

const AdministrationContainer = () => {
  return <Typography variant='h3'>Administration page</Typography>;
};

export default AdministrationContainer;
